<div *ngIf="monetaryValue" [ngClass]="pnLClass">
  {{ monetaryValue.value | pnlTest: monetaryValue.currencyCode : suffix }}
</div>
<ng-container *ngIf="!monetaryValue">
  -
</ng-container>